import { cx, EmptyState } from '../Ui';
import { ControlTowerOrderCard } from './ControlTowerOrderCard';
import type { OrderView } from './control-tower-utils';

type ColumnTone = 'amber' | 'blue' | 'green';

const columnStyles: Record<ColumnTone, string> = {
  amber: 'border-amber-200 bg-amber-50/40',
  blue: 'border-blue-200 bg-blue-50/40',
  green: 'border-emerald-200 bg-emerald-50/40',
};

interface ControlTowerColumnProps {
  title: string;
  tone: ColumnTone;
  orders: OrderView[];
  emptyText: string;
  onSelectOrder(order: OrderView): void;
}

export function ControlTowerColumn({ title, tone, orders, emptyText, onSelectOrder }: ControlTowerColumnProps) {
  return (
    <section className={cx('flex flex-col rounded-2xl border p-3', columnStyles[tone])}>
      <header className="mb-3 flex items-center justify-between gap-2 px-1">
        <h3 className="text-sm font-black uppercase tracking-wide text-foreground">{title}</h3>
        <span className="rounded-full bg-white px-2.5 py-0.5 text-xs font-bold text-muted">{orders.length}</span>
      </header>
      <div className="grid gap-3">
        {orders.length === 0 ? (
          <EmptyState title={title} description={emptyText} />
        ) : (
          orders.map((order) => <ControlTowerOrderCard key={order.id} order={order} onSelectOrder={onSelectOrder} />)
        )}
      </div>
    </section>
  );
}
